<template>
  <div class="a-good-company-stage">
    <CdnImage
      class="a-good-company-stage__background"
      alt=""
      preload
      src="/content/content-images/landingpages/themenwelt-refresh/24ae7a75252b638b73c10fb7a46971ae/buehne-hero-iphone-s@2x.jpg"
      src-sm="/content/content-images/landingpages/themenwelt-refresh/38e517be6225fd49f7454d4deeb5262a/buehne-hero-iphone-m@2x.jpg"
      src-md="/content/content-images/landingpages/themenwelt-refresh/f8fdd12cc43aa047cb86ef2d55f166ea/buehne-hero-iphone-l@2x.jpg"
      sizes="xs:100vw sm:100vw md:200vw lg:200vw"
    />
    <GridContainer
      class="a-good-company-stage__container"
      padding
    >
      <div class="a-good-company-stage__content">
        <slot name="content" />
      </div>
      <div class="a-good-company-stage__hero">
        <slot name="hero" />
      </div>
    </GridContainer>
  </div>
</template>

<script>
import { GridContainer } from '@i22/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';

export default {
  name: 'AGoodCompanyStage',
  components: { CdnImage, GridContainer },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.a-good-company-stage {
  background-color: #fff;
  margin-bottom: 75px;
  height: 720px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 100%;

  &__background,
  &__container {
    grid-column: 1;
    grid-row: 1;
  }

  &__background {
    width: 100%;
    height: 100%;

    :deep(img) {
      object-fit: cover;
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  &__container {
    position: relative;
    justify-content: flex-start;
    overflow: unset;
    flex-direction: column;
    @include mq($mq-sm) {
      flex-direction: row;
    }
  }
  &__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: $grid-base * 4 $grid-base $grid-base * 4 0;
    @include mq($mq-sm) {
      padding: $grid-base * 4 $grid-base $grid-base * 4 0;
      max-width: 50%;
    }
    @include mq($mq-lg) {
      padding: $grid-base * 4 $grid-base $grid-base * 6 0;
    }
    @include mq($mq-xl) {
      max-width: 40%;
      padding: $grid-base * 3 $grid-base $grid-base * 8 0;
    }
  }
  &__hero {
    display: flex;
    justify-content: center;
    max-width: 420px;
    transform: translateY(25px);
    @include mq($mq-sm) {
      transform: translateY(0);
      position: absolute;
      width: 50%;
      top: 0;
      height: calc(100% + 50px);
      right: 0;
      max-width: 560px;
    }
    @include mq($mq-lg) {
      max-width: 580px;
    }
    @include mq($mq-xl) {
      max-width: initial;
    }
  }
  :deep(.grid-container) {
    height: 100%;
  }
  :deep(.a-good-company__hero-update) {
    @include mq($mq-sm) {
      position: absolute;
      bottom: 0;
      left: 0;
    }
    @include mq($mq-xl) {
      bottom: auto;
      left: auto;
      top: 0;
      right: 0;
    }
  }
}
</style>
